/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import classname from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import range from 'lodash/range';
import map from 'lodash/map';
import OperatorsDropdown from '../OperatorDropdown/OperatorDropdown';

function OperatorSelection({ node, updateOperator, operators }) {
  const [selectedOperator, onSelectionOperator] = useState({ label: node.operator ? node.operator : node.defaultOperation });
  const [operatorQualifierList, setOperatorQualifierList] = useState([]);
  const [operatorQualifierValue, setOperatorQualifierValue] = useState(node.operatorQualifier ? node.operatorQualifier : '');

  const onOperatorChange = (s) => {
    onSelectionOperator(s);
    if (s.supportsQualifier) {
      const operatorQualifiers = map(range(s.lowerQualifierBound, s.upperQualifierBound + 1), (num) => ({ id: num, label: num }));
      setOperatorQualifierList(operatorQualifiers);
      setOperatorQualifierValue(s.defaultQualifier);
    }
    updateOperator({ operator: s.label, qualifier: s.defaultQualifier, node });
  };
  const operatorSupportsQualifier = (operator) => get(operators, `${operator}.supportsQualifier`);
  return (
    <div
      className={classname('ql__operator', {
        'ql__operator__with-qualifier': node.operatorQualifier || operatorSupportsQualifier(node.operator),
      })}>
      {selectedOperator && selectedOperator.label && (
        <OperatorsDropdown
          options={operators}
          selected={{ label: selectedOperator.label }}
          onChange={(s) => {
            onOperatorChange(s);
          }}
        />
      )}
      {selectedOperator && selectedOperator.supportsQualifier && (
        <OperatorsDropdown
          options={operatorQualifierList}
          selected={{ label: operatorQualifierValue }}
          onChange={(s) => {
            setOperatorQualifierValue(s.label);
            updateOperator({ operator: selectedOperator.label, qualifier: s.label, node });
          }}
        />
      )}
    </div>
  );
}

OperatorSelection.propTypes = {
  node: PropTypes.object,
  updateOperator: PropTypes.func,
  operators: PropTypes.array,
};

export default OperatorSelection;
